<div class="modal fade search_04" id="{{ID}}" tabindex="0" attr.aria-labelledby="{{ID}}Label" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title sr-only" id="{{ID}}Label">{{'searchToolModal.materialModalTitle' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" attr.aria-label="{{'modal.close' | translate}}">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <section class="clearfix p-h-md" id="top_function">
          <form method="post" action="" autocomplete="off">
            <div class="bar">
              <label for="searchSubject" class="sr-only">{{'searchpage.subject' | translate}}</label>
              <select id="searchSubject" name="searchSubject" [(ngModel)]="searchSubject">
                <option [ngValue]="undefined">{{'searchpage.allSubject' | translate}}</option>
                <ng-container *ngFor="let opt of SUBJECT_OPTIONS">
                  <option [ngValue]="opt.label">{{opt.label}}</option>
                </ng-container>
              </select>
  
              <div class="selectbar" style="pointer-events: none; user-select: none;" aria-hidden="true">｜</div>
    
              <div class="searchbar">
                <label for="search_tool_searchKeyword" class="sr-only">{{'keyword' | translate}}</label>
                <input id="search_tool_searchKeyword" type="text" placeholder="{{'searchpage.searchPlaceholder2' | translate}}"
                name="searchKeyword" [(ngModel)]="searchKeyword" (ngModelChange)="onKeywordChange($event)"
                (focus)="onFocusSearchKeywordInput()" #searchKeywordInput>
                <tm-auto-complete-options *ngIf="isOpened" #skACO="tmAutoCompleteOptions"
                [options]="keywordsOptions"
                [togglerEl]="searchKeywordInput"
                id="search_tool_searchKeywordOptions"
                label="{{'keywordAutoCompleteOptions' | translate}}"
                (selected)="searchKeyword = $event; onKeywordChange($event); onClickSearch();"
                ></tm-auto-complete-options>
              </div>
              
              <a href="javascript:void(0)" role="button" title="{{'search' | translate}}" class="searchtool"
              (click)="onClickSearch($event)">
                <i class="fa fa-search" aria-hidden="true"></i>
                <span class="sr-only">{{'search' | translate}}</span>
              </a>
            </div>
          </form>

          <div class="tools">
            <label for="format" (click)="formatFilterList.focus()" class="sr-only">{{'searchpage.dataFormat' | translate}}</label>
            <ul id="format" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.dataFormat' | translate)}) }}" role="listbox" tabindex="-1" #formatFilterList>
              <a href="javascript: void(0)" title="{{'all' | translate}}"
              role="option" [class.active]="!searchFilter.format"
              aria-disabled="false" [attr.aria-selected]="!searchFilter.format"
              (click)="selectFormatAll()"><li><span class="tools001">{{'all' | translate}}</span></li></a>
              <ng-container *ngFor="let opt of FORMAT_OPTIONS; index as i">
                <a href="javascript: void(0)" title="{{opt.label}}"
                  role="option" [class.active]="searchFilter.format === opt.value"
                  aria-disabled="false" [attr.aria-selected]="searchFilter.format === opt.value"
                  (click)="selectFormat(opt.value)"><li><span class="tools00{{i + 2}}">{{opt.label}}</span></li></a>&nbsp;
              </ng-container>
            </ul>
          </div>

          <div class="iamhr"></div>

          <div class="condition" *ngIf="myKeywordRecs && myKeywordRecs.length">
            <label for="record" (click)="recordFilterList.focus()">{{'searchToolModal.youLatestSearch' | translate}}</label>
            <ul id="record" attr.aria-label="{{'searchToolModal.youLatestSearchKeyword' | translate}}" role="listbox" tabindex="-1" #recordFilterList>
              <ng-container *ngFor="let key of myKeywordRecs; index as i">
                <a role="option" routerLink="./datasearch" [queryParams]="{keyword: key}" queryParamsHandling="merge" class="condition_tap"><li>{{key}}</li></a>&nbsp;
              </ng-container>
            </ul>
          </div>

          <div class="condition2" *ngIf="hotKeyWords && hotKeyWords.length">
            <label for="hot" (click)="hotFilterList.focus()">{{'explorePage.everyoneFocusOn' | translate}}</label>
            <ul id="hot" attr.aria-label="{{'searchToolModal.everyoneFocusOnKeyword' | translate}}" role="listbox" tabindex="-1" #hotFilterList>
              <ng-container *ngFor="let key of hotKeyWords; index as i">
                <a role="option" routerLink="./datasearch" [queryParams]="{keyword: key}" queryParamsHandling="merge" class="condition_tap"><li>{{key}}</li></a>&nbsp;
              </ng-container>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>